const fields = {
  ok: "ok",
  next: "next",
  back: "back",
  create: "create",
  update: "update",
  edit: "edit",
  selectAll: "Select All",
  selected: "Selected {selected} Items",
  filtered: "Filtered {filtered}",
  rmFilters: "Remove Filters",
  showFilters: "Show Filters",
  hideFilters: "Hide Filters",
  refresh: "Refresh",
  delete: "Delete",
  ignore: "Ignore",
  deleteMessage: "Are you sure you want to delete this item?",
  do: "Do",
  dont: "Dont",
  description: "Description",
  call_me: "Call Me?",
  number: "Number",
  price: "Price",

  title: "Title",
  alias: "Alias",
  city: "City",
  state: "ُState",
  manager: "Manager",
  firstname: "Firstname",
  lastname: "Lastname",
  national_code: "National Code",
  birth_date: "Birth Date",
  medical_number: "Dedical Number",
  specialist: "Specialist",
  gender: "Gender",
  skinColor: "Skin Color",
  man: "Man",
  woman: "Woman",
  email: "Email",
  address: "Address",
  cellphone: "Cellphone",
  generalDentist: "General Dentist",
  restorativeDentistry: "Restorative Dentistry",
  prosthodontics: "Prosthodontics",
  orthodontics: "Orthodontics",
  activity: "Activity",

  //Skin Colors
  lightSkin: "Light",
  mediumSkin: "Medium",
  darkSkin: "Dark",
  veryDarkSkin: "Very Dark",
};
export default fields;
